module.exports = __webpack_public_path__ + "img/sz.d414bc94.svg";